import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
import FeatureHighlight from '../../components/cultivars/FeatureHighlight'
import ProductShowcase from '../../components/cultivars/Georgia/ProductShowcase'
import Footer from '../../components/Footer'
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import { Helmet } from 'react-helmet'

const Georgia = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
     <Helmet>
        <title>Georgia - Smooth & Mellow Cannabis Cultivar | BeyondBloom™</title>
        <meta
          name="description"
          content="Discover Georgia, a smooth and mellow cannabis cultivar perfect for unwinding after a long day. Enjoy a balanced, relaxing experience."
        />
        <meta
          name="keywords"
          content="Georgia strain, cannabis, mellow cultivar, relaxation, premium cannabis, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Georgia - Smooth & Mellow Cannabis Cultivar | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Discover Georgia, a smooth and mellow cannabis cultivar perfect for unwinding after a long day."
        />
        <meta property="og:image" content="/images/georgia.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/georgia" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Georgia - Smooth & Mellow Cannabis Cultivar | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Discover Georgia, a smooth and mellow cannabis cultivar perfect for unwinding after a long day."
        />
        <meta name="twitter:image" content="/images/georgia.png" />
      </Helmet>
    <Navbar/>
    <ProductShowcase/>
    <FeatureHighlight/>
    <CultivarDisplay />
    <Cta />
    <Footer/>
</>
  )
}

export default Georgia